import { combineReducers } from 'redux';

const defaultNumbers = [];
const numbers = (state = defaultNumbers, action) => {
  switch (action.type) {
    case 'GET_NUMBERS_SUCCESS':
      return action.numbers;
    default:
      return state;
  }
};

const defaultDeleteModal = false;
const deletePhoneModal = (state = defaultDeleteModal, action) => {
  switch (action.type) {
    case 'DELETE_PHONE_OPEN':
      return true;
    case 'DELETE_PHONE_CANCEL':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  numbers,
  deletePhoneModal,
});
